import { render } from "./SearchArticles.vue?vue&type=template&id=11a3834a"
import script from "./SearchArticles.vue?vue&type=script&lang=js"
export * from "./SearchArticles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__